module.exports = __webpack_public_path__ + "static/22-proptech-will-be-the-tipping-point-for-the-real-estate-industry-d3d7ac0504ad06dc4235244c3132eafa.jpg";